var self = undefined;
import { formatDate } from './dateformat'

export default {
	bindVue(vue) {
		self = vue;
	},
	install(Vue) {
		Vue.filter('toNumber', function(value) {
			return self.$fixNumber(value, true)
		});
		Vue.filter('formatDate',function(time){
            if(time =='' || time == null){
                return '';
            }
            var date = new Date(time);
            return formatDate(date, 'yyyy年MM月dd日');
        });
	}
}
